module.exports = __webpack_public_path__ + "img/BA.ae4d815d.svg";